export const environment = {
  production: false,
  apiBaseUrl: 'https://c7zyxacqsi.execute-api.us-east-1.amazonaws.com/dev',
  wsApiBaseUrl: 'https://66ff2d6he8.execute-api.us-east-1.amazonaws.com/dev',
  // Facturas
  facturasUrl: 'https://app.stupendo.ec/receiver/login',
  // Soporte
  soporteEmail:'jessicazavala@softwareevolutivo.com.ec',
  //'pedidosb2b@cotopaxi.com.ec',
  soportePhone: '593993992059',
  buildVersion: 'local',
  buildSource: 'local',
  buildEnvironment: 'local'
};
